import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '../context/ThemeContext';

const ThemeWrapper = ({ children }) => {
  const { currentTheme } = useTheme();

  // Safety check to ensure we never pass null to MUI ThemeProvider
  if (!currentTheme) {
    console.warn('ThemeWrapper: currentTheme is null, this should not happen');
    return <div>Loading theme...</div>;
  }

  return (
    <ThemeProvider theme={currentTheme}>
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
